import styled, { css } from 'styled-components';
import { withTheming, Shape, getFocusStyles, Spacing, IconSize, Icon } from '@doordash/design-language';
import { MenuCaretDirection } from './types.js';
import { MenuControlPadding } from './constants.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var MenuControlButton = withTheming(styled.button.attrs(function () {
  return {
    type: 'button'
  };
}).withConfig({
  displayName: "styles__MenuControlButton",
  componentId: "sc-8cd41l-0"
})(["height:", "px;color:", ";border-radius:", "px;z-index:1;padding:", ";border:none;box-shadow:", ";background-color:", ";white-space:nowrap;max-width:100%;", ";", " &:focus-within{background-color:", ";", ";}"], function (props) {
  return function (_ref) {
    var theme = _ref.theme;
    return theme.Size["Field".concat(props.size)];
  };
}, function (props) {
  return props.theme.Colors.FieldsForegroundInactive;
}, function (props) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return theme.Shape.Field === Shape.Pill ? theme.Size["Field".concat(props.size)] * 2 : theme.BorderRadius.FieldsInputDefault;
  };
}, function (props) {
  return "0px ".concat(props.size && MenuControlPadding[props.size], "px");
}, function (_ref3) {
  var theme = _ref3.theme;
  return "inset 0 0 0 ".concat(theme.BorderWidth.FieldsDefault, "px ").concat(theme.Colors.FieldsBorderInactive);
}, function (props) {
  return function (_ref4) {
    var theme = _ref4.theme;
    return props.isExpanded ? theme.Colors.FieldsBackgroundActive : theme.Colors.FieldsBackgroundInactive;
  };
}, function (props) {
  return !props.isInline && "min-width: 100%";
}, function (props) {
  return function (_ref5) {
    var theme = _ref5.theme;
    return props.isExpanded && getFocusStyles({
      theme: theme,
      focusColor: theme.Colors.FieldsBorderActive,
      shouldUseFocusRing: false,
      shouldBeInset: true,
      focusWidth: theme.BorderWidth.FieldsFocus
    });
  };
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.Colors.FieldsBackgroundActive;
}, function (_ref7) {
  var theme = _ref7.theme;
  return getFocusStyles({
    theme: theme,
    focusColor: theme.Colors.FieldsBorderActive,
    shouldUseFocusRing: false,
    shouldBeInset: true,
    focusWidth: theme.BorderWidth.FieldsFocus
  });
}));
var MenuContainer = styled.div.withConfig({
  displayName: "styles__MenuContainer",
  componentId: "sc-8cd41l-1"
})(["", ";padding:", "px 0;", ";"], function (props) {
  return props.setContentWidthAsControlWidth ? 'width: 100%' : '';
}, Spacing.XxSmall, function (props) {
  return props.menuContainerStyles && css(["", ";"], _objectSpread({}, props.menuContainerStyles));
});
var StyledMenuItemWrapper = withTheming(styled.div.withConfig({
  displayName: "styles__StyledMenuItemWrapper",
  componentId: "sc-8cd41l-2"
})(["", ""], function (props) {
  return function (_ref8) {
    var _props$item$listCellP;

    var theme = _ref8.theme;
    return (props.item.onClick || ((_props$item$listCellP = props.item.listCellProps) === null || _props$item$listCellP === void 0 ? void 0 : _props$item$listCellP.href)) && css(["& > *:first-child{background:", ";&:hover{background:", ";}&:active{background:", ";}}"], theme.Colors.MenuItemBackground, theme.Colors.MenuItemBackgroundHovered, theme.Colors.MenuItemBackgroundPressed);
  };
}));
var MenuItemTitleWrapper = styled.div.withConfig({
  displayName: "styles__MenuItemTitleWrapper",
  componentId: "sc-8cd41l-3"
})(["display:flex;min-height:", "px;align-items:center;"], IconSize.Medium);
var RotatingMenuIcon = styled(Icon).withConfig({
  displayName: "styles__RotatingMenuIcon",
  componentId: "sc-8cd41l-4"
})(["transform:rotate(", ");transition:transform 0.2s ease-out;"], function (props) {
  return props.direction === MenuCaretDirection.Up ? '0deg' : '-180deg';
});

export { MenuContainer, MenuControlButton, MenuItemTitleWrapper, RotatingMenuIcon, StyledMenuItemWrapper };
